import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch } from "react-redux";

import { parseDate } from "@awe-web/shared/lib";
import { setCiStation, setCoDateTime, setCoStation } from "../../stations/actions.js";
import { B2C_SelectStationAndTime } from "../../routing/routes.js";
import { BMW_SELECTED_STATION_AND_TIME } from "../../stations/store.js";

export default function B2CReservationEntry() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [searchParams] = useSearchParams();
  const coStationId = searchParams.get('coStationId');
  const ciStationId = searchParams.get('ciStationId');
  const coDateTime = searchParams.get('coDateTime');
  const ciDateTime = searchParams.get('ciDateTime');

  useEffect(() => {
    if (coStationId) {
      dispatch(setCoStation(coStationId));
    }
    if (ciStationId) {
      dispatch(setCiStation(ciStationId));
    }

    let strCODateTime;
    if (coDateTime) {
      try {
        strCODateTime = parseDate(coDateTime);
        dispatch(setCoDateTime(strCODateTime));
      } catch (error) {
      }
    }
    let strCIDateTime;
    if (ciDateTime) {
      try {
        strCIDateTime = parseDate(ciDateTime);
        dispatch(setCoDateTime(strCIDateTime));
      } catch (error) {
      }
    }

    sessionStorage.setItem(BMW_SELECTED_STATION_AND_TIME, JSON.stringify({
      coStation: { id: coStationId },
      ciStation: { id: ciStationId },
      coDateTime: strCODateTime,
      ciDateTime: strCIDateTime
    }));

    navigate(B2C_SelectStationAndTime.path());
  }, [ciDateTime, ciStationId, coDateTime, coStationId, dispatch, navigate]);

  return null;
}
